import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import "./PRSValidationMessages.scss"
// Components
import { PrimeButton } from "components-design-system"

// helper
import { findFieldAndValue } from "../../utilities/PRSValidation"

const PRSValidationMessages = ({
  origin,
  setOpenModal,
  onOpenModal,
  gridProps,
  messages,
  studyData = null,
  hideSubmit = false,
  hideActions = false,
}) => {
  const [sitesMap, setSitesMap] = useState(new Map())

  useEffect(() => {
    if (gridProps.source) {
      if (gridProps.source === "study-details") {
        let tempMap = new Map()
        tempMap.set(gridProps?.node?.data?.id, gridProps?.node?.data)
        setSitesMap(tempMap)
      }
    }
  }, [gridProps?.node?.data, gridProps?.source])

  const onSaveChanges = () => {
    setOpenModal(false)
  }

  return (
    <div className="prs-validation-container">
      <div className="prs-validation-msg-modal-body">
        <div className="prs-validation-msgs-container">
          {messages &&
            messages.map((item, i) => {
              return (
                <Message
                  key={item.source ? item.source : item.field_key + i}
                  onOpenModal={onOpenModal}
                  messages={messages}
                  data={gridProps?.node?.data}
                  studyData={studyData}
                  message={item}
                  sitesMap={sitesMap}
                  origin={origin}
                  hideActions={hideActions}
                />
              )
            })}
        </div>
      </div>
      <div className="prs-validation-action-container">
        <PrimeButton
          onClick={() => setOpenModal(false)}
          style={{ marginRight: 16 }}
        >
          Cancel
        </PrimeButton>
        {hideSubmit !== true && (
          <PrimeButton
            type="primary"
            onClick={() => onSaveChanges()}
          >
            Save Changes
          </PrimeButton>
        )}
      </div>
    </div>
  )
}

export default PRSValidationMessages

const Message = ({ data, message, sitesMap, onOpenModal, messages, studyData, origin, hideActions }) => {
  const navigate = useNavigate()
  const [iconClass, setIconClass] = useState(null)
  const [type, setType] = useState("")
  const [selectedSite, setSelectedSite] = useState(null)
  const [fieldLabel, setFieldLabel] = useState("")
  const [fieldValue, setFieldValue] = useState("")

  useEffect(() => {
    let type = message.severity || message.type
    if ((message.severity || message.type) && message.site_db_id) {
      if (type === "ERROR") setIconClass("fas fa-do-not-enter")
      else if (type === "WARNING") setIconClass("fas fa-exclamation-triangle")
      else setIconClass("fas fa-info-circle")
      setType(message.severity)
      if (sitesMap.has(message.site_db_id)) {
        setSelectedSite(sitesMap.get(message.site_db_id))
      }
    } else if (message.severity || message.type) {
      if (type === "ERROR") {
        setIconClass("fas fa-times-circle")
        setType("NON-SITE")
      } else if (type === "WARNING") {
        setIconClass("fas fa-exclamation-triangle")
        setType(message.severity)
      } else {
        setIconClass("fas fa-info-circle")
        setType(message.severity)
      }
    }
  }, [message, sitesMap])

  useEffect(() => {
    let { label, value } = findFieldAndValue(message, sitesMap)
    setFieldLabel(label)
    setFieldValue(value)
    // TODO: get value of field
  }, [message, sitesMap])

  const onEditSite = () => {
    onOpenModal("edit-site", { data: selectedSite }, data, messages)
  }

  let title = ""
  if (data && data.study_id) title = data.study_id

  const getUrl = () => {
    let type = message.severity || message.type
    let hash = "#locations"
    if (type === "WARNING" || type === "NOTE" || type === "NON-SITE") hash = `#study-data`
    return `/study/${data.uniqid}/${hash}`
  }
  const getIconColor = (type) => {
    switch (type) {
      case "ERROR":
        return "validation-icon-error"
      case "WARNING":
        return "validation-icon-warning "
      case "NOTE":
        return "validation-icon-note"
      case "NON-SITE":
        return "validation-icon-non-site "
      default:
        return "validation-icon-note"
    }
  }

  return (
    <div className="prs-validation-msg-container">
      <div className="prs-validation-msg-info-container">
        <div
          className="prs-validation-msg-text"
          style={{ marginBottom: 16 }}
        >
          {title}
        </div>
        {message.site_db_id && (
          <div className="prs-msg-field-container">
            <div
              className={`prs-validation-msg-text `}
              style={{ color: "#525252" }}
            >
              {fieldLabel}
            </div>
            <div
              className={`prs-validation-msg-text `}
              style={{ marginLeft: 16 }}
            >
              {fieldValue}
            </div>
          </div>
        )}
        <div className="prs-msg-severity">
          <i
            style={{
              marginRight: 12,
              marginTop: 3,
              width: 10,
            }}
            className={`${iconClass} ${getIconColor(type)}`}
          />
          <div
            className={`prs-validation-msg-text  ${getIconColor(type)}`}
            style={{ width: "90%" }}
            type={type}
          >
            {message.message || message.text}
          </div>
        </div>
      </div>

      <div className="prs-validation-msg-action-container">
        {data?.uniqid && (
          <PrimeButton
            variant="link"
            onClick={() => navigate(getUrl())}
          >
            Update
          </PrimeButton>
        )}
        {origin === "locations" && hideActions === false && (
          <PrimeButton
            variant="link"
            onClick={() => onEditSite()}
          >
            Update
          </PrimeButton>
        )}
      </div>
    </div>
  )
}
